/**
 * Appvia Home Page Module
 *
 * This module provides the custom Appvia home page for the Backstage app.
 * It's separated from the layout module to allow apps to use one without the other.
 *
 * @packageDocumentation
 */

import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageExtension } from '../extensions/home';

/**
 * Frontend module that provides the Appvia home page.
 *
 * This module targets the 'app' plugin and registers the home page extension
 * at the root path ('/').
 *
 * @public
 */
export const appviaHomeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [HomePageExtension],
});
